import { render, staticRenderFns } from "./FamilyPermittedFunctionList.vue?vue&type=template&id=042f5fb8&scoped=true&lang=pug"
import script from "./FamilyPermittedFunctionList.vue?vue&type=script&lang=ts"
export * from "./FamilyPermittedFunctionList.vue?vue&type=script&lang=ts"
import style0 from "./FamilyPermittedFunctionList.vue?vue&type=style&index=0&id=042f5fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f5fb8",
  null
  
)

export default component.exports